import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
import { Moon, Activity, Brain, Battery } from 'lucide-react';
export function PageSleep() {
  return <Page pageNumber={29} variant="light" data-id="element-1169">
      <div className="flex h-full gap-12" data-id="element-1170">
        {/* Left 1/3 Column */}
        <div className="w-1/3 flex flex-col" data-id="element-1171">
          <div className="h-[260px] w-full mb-6 overflow-hidden" data-id="element-1172">
            <img src="https://images.unsplash.com/photo-1531353826977-0941b4779a1c?w=800&q=80" alt="Peaceful bedroom" className="w-full h-full object-cover" data-id="element-1173" />
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center mb-8" data-id="element-1174">
            <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-1175">
              Daily Target
            </h2>
            <p className="text-3xl font-serif text-[#1F1F1F]" data-id="element-1176">7-9 hours</p>
            <p className="text-xs text-[#7A7A70] mt-1" data-id="element-1177">per night</p>
          </div>

          <div className="border-t border-[#D8D8D0] pt-6" data-id="element-1178">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-3" data-id="element-1179">
              Practical Tips
            </h3>
            <ul className="space-y-3 text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-1180">
              <li className="flex gap-2" data-id="element-1181">
                <span className="text-tealslate" data-id="element-1182">•</span>
                Maintain a consistent bedtime and wake time
              </li>
              <li className="flex gap-2" data-id="element-1183">
                <span className="text-tealslate" data-id="element-1184">•</span>
                Keep your bedroom dark, quiet, and cool (65-68°F)
              </li>
              <li className="flex gap-2" data-id="element-1185">
                <span className="text-tealslate" data-id="element-1186">•</span>
                Limit screen time 1 hour before bed
              </li>
              <li className="flex gap-2" data-id="element-1187">
                <span className="text-tealslate" data-id="element-1188">•</span>
                Avoid caffeine after 2:00 PM
              </li>
            </ul>
          </div>
        </div>

        {/* Right 2/3 Column */}
        <div className="w-2/3 flex flex-col" data-id="element-1189">
          <div className="mb-8 pt-4" data-id="element-1190">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1191">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1192">
              Prioritizing <span className="text-tealslate" data-id="element-1193">Sleep</span>
            </h1>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-1194" />
          </div>

          <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-10" data-id="element-1195">
            Poor sleep increases cortisol, which increases insulin resistance,
            which makes weight loss harder. It also increases cravings for sugar
            and carbohydrates the next day.
          </p>

          <h2 className="text-xl font-serif text-[#1F1F1F] mb-6" data-id="element-1196">
            Why It Matters for GLP-1
          </h2>

          <div className="grid grid-cols-2 gap-4 mb-10" data-id="element-1197">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1198">
              <Brain className="w-6 h-6 text-tealslate mb-3" data-id="element-1199" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1200">
                Hormone Balance
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1201">
                Poor sleep increases ghrelin (hunger) and reduces leptin
                (satiety).
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1202">
              <Activity className="w-6 h-6 text-tealslate mb-3" data-id="element-1203" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1204">
                Insulin Sensitivity
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1205">
                Sleep deprivation impairs how your body handles blood sugar.
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1206">
              <Battery className="w-6 h-6 text-tealslate mb-3" data-id="element-1207" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1208">
                Muscle Recovery
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1209">
                Most muscle repair happens during deep sleep phases.
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1210">
              <Moon className="w-6 h-6 text-tealslate mb-3" data-id="element-1211" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1212">
                Energy Levels
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1213">
                Combats the fatigue often associated with calorie deficits.
              </p>
            </div>
          </div>

          <div className="mt-auto" data-id="element-1214">
            <SupplementCallout title="Sleep Support" description="Melatonin (0.5-3mg) for sleep onset and magnesium glycinate (200-400mg) for sleep quality are both well-researched options. Take 30-60 minutes before bed." data-id="element-1215" />
          </div>
        </div>
      </div>
    </Page>;
}